// XNGAGE CONFIDENTIAL
// __________________________
//
// Copyright (C) 2023 Xngage - All Rights Reserved
//
// All code or information contained herein is, and remains the
// property of Xngage LLC and its customers.  The intellectual
// and technical concepts contained are proprietary to Xngage LLC
// and may be covered by U.S. and Foreign Patents, patents in
// process, and are protected by trade secret or copyright law.
// Dissemination of this information or reproduction of this material
// is strictly forbidden unless prior written permission is obtained
// from Xngage LLC.
//

import { PoLineModel, updatePoNumbers as updatePoNumbersApi } from "@guestsupply/App/Services/PoNumbersService";
import { createUserAccount } from "@guestsupply/App/Services/RequestWebsiteAccessService";
import { AccountInfoModel, UserAccountModel } from "@guestsupply/XDL/types";
import {
    ApiHandler,
    createHandlerChainRunner,
    HasOnError,
    HasOnSuccess,
} from "@insite/client-framework/HandlerCreator";
import { ServiceResult } from "@insite/client-framework/Services/ApiService";
import loadCurrentCart from "@insite/client-framework/Store/Data/Carts/Handlers/LoadCurrentCart";

export interface UpdatePoNumbersParameter {
    lines: PoLineModel[];
}

type HandlerType = ApiHandler<
    UpdatePoNumbersParameter & HasOnSuccess & HasOnError<string>,
    {
        result?: any;
        errorMessage?: string;
        successful: boolean;
    }
>;

export const PopulateApiParameter: HandlerType = props => {
    const { onSuccess, onError, ...apiParameter } = props.parameter;
    props.apiParameter = apiParameter;
};

export const RequestDataFromApi: HandlerType = async props => {
    if (!props.apiParameter.lines) {
        return;
    }

    props.apiResult = await updatePoNumbersApi(props.apiParameter.lines);
};

export const LoadCart: HandlerType = props => {
    props.dispatch(loadCurrentCart());
};

export const ExecuteOnErrorCallback: HandlerType = props => {
    if (!props.apiResult.successful) {
        props.parameter.onError?.(props.apiResult.errorMessage!);
    }
};

export const chain = [PopulateApiParameter, RequestDataFromApi, LoadCart, ExecuteOnErrorCallback];

const updatePoNumbers = createHandlerChainRunner(chain, "UpdatePoNumbers");

export default updatePoNumbers;
